import { LOGIN_BASE_URL } from "../../utils/constants";

export const refreshAuthToken = async (): Promise<string> => {
  const refreshTokenValue = localStorage.getItem("refreshToken");

  if (!refreshTokenValue) {
    throw new Error('No refresh token available');
  }

  const response = await fetch(LOGIN_BASE_URL + "/auth/refresh", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({refreshToken: refreshTokenValue}),
  });

  if (response.status === 200) {
    console.log("Refresh token successful");
    const res = await response.json();
    localStorage.setItem("token", res.accessToken);
    localStorage.setItem("refreshToken", res.refreshToken);
    return res.accessToken;
  } else {
    throw new Error('Token refresh failed');
  }
};